import React from "react";
import AppBar from "../components/AppBar";
import { Hero } from "../components/landing/Hero";
import { Tours } from "../components/landing/Tours";
import { About } from "../components/landing/About";

import { Testimonials } from "../components/landing/Testimonials";
import { Contact } from "../components/landing/Contact";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-white">
      <AppBar />
      <Hero />
      <Tours />
      <About />

      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
